import React from 'react';
import { Button, FormControl, MenuItem, Select, Stack, Typography } from '@mui/material';

const PAGE_SIZES = [25, 50, 100];

export default function AdminPagination({
  page = 1,
  pages = 1,
  total = 0,
  pageSize = 25,
  label = 'records',
  disabled = false,
  onPageChange,
  onPageSizeChange,
}) {
  const safePages = Math.max(1, Number(pages) || 1);
  const safePage = Math.min(Math.max(1, Number(page) || 1), safePages);
  return (
    <Stack className="admin-pagination" direction={{ xs: 'column', md: 'row' }} alignItems={{ xs: 'stretch', md: 'center' }} justifyContent="space-between" spacing={1.5}>
      <Typography variant="body2" color="text.secondary">
        {Number(total) || 0} {label} · Page {safePage} of {safePages}
      </Typography>
      <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap" useFlexGap>
        <Typography variant="caption" color="text.secondary">Rows per page</Typography>
        <FormControl size="small">
          <Select
            value={pageSize}
            onChange={(event) => onPageSizeChange?.(Number(event.target.value))}
            disabled={disabled}
            inputProps={{ 'aria-label': `Rows per page for ${label}` }}
          >
            {PAGE_SIZES.map((size) => <MenuItem key={size} value={size}>{size}</MenuItem>)}
          </Select>
        </FormControl>
        <Button variant="outlined" size="small" disabled={disabled || safePage <= 1} onClick={() => onPageChange?.(safePage - 1)}>Previous</Button>
        <Button variant="outlined" size="small" disabled={disabled || safePage >= safePages} onClick={() => onPageChange?.(safePage + 1)}>Next</Button>
      </Stack>
    </Stack>
  );
}
